"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SimpleStagedObject = _interopRequireDefault(require("redux-less/SimpleStagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _constants = require("settings-ui-sdk/BccEmail/constants");

var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.EMAIL_BCC_REQUESTED,
  initialValue: ''
}];

var _default = new _SimpleStagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing.email.staging.setBccEmailSettings;
  },
  namespace: 'email',
  objectType: _constants.BCC_EMAIL,
  properties: properties
});

exports.default = _default;
module.exports = exports.default;